import React, { PropsWithChildren } from "react";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./Classification.module.css";

interface Props {
  style?: React.CSSProperties;
  onClick?: () => void;
}

const SubtleSpan: React.FC<PropsWithChildren<Props>> = ({
  children,
  style,
  onClick,
}) => {
  return (
    <span
      onClick={onClick}
      className={toClassName(
        styles.sutbleSpan,
        onClick !== undefined ? styles.sutbleSpanWithOnCLick : undefined
      )}
      style={{
        ...style,
        cursor: onClick !== undefined ? "pointer" : "default",
      }}
    >
      {children}
    </span>
  );
};

export default SubtleSpan;
